// extracted by mini-css-extract-plugin
module.exports = {"container":"c6e8ba5398--container--EKMOk","container--multiple-phones":"c6e8ba5398--container--multiple-phones--QGdUt"};